import { Button, Form, Input, message, Select, Spin } from 'antd';
import { Rule } from 'antd/lib/form';
import { useLoginValidation, passwordPolicyRules } from 'api';
import { getSelectList, SelectList, SelectPayload } from 'api/dashboard';
import { adduserList, UserPayload } from 'api/profile';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  isAdmin: boolean;
  onSubmit: (values: UserPayload) => Promise<void>;
};

const inituser: UserPayload = {};
const initPartners: SelectList[] = [];

const AddUser = ({ isAdmin, onSubmit }: Props) => {
  const navigate = useNavigate();
  const { Option } = Select;
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [firstname, setFirstName] = useState('');
  const [lastname, setLastName] = useState('');
  const [roleId, setRoleId] = useState(0);
  const [sourceId, setSourceId] = useState(0);
  const [form] = Form.useForm<UserPayload>();
  const [_user, setUser] = useState(inituser);
  const [partnerList, setPartners] = useState(initPartners);
  const [adminList, setAdminList] = useState(initPartners);
  const [roleList, setRoles] = useState(initPartners);
  const [isLoading, setLoading] = useState(false);

  const required: Rule[] = [
    {
      type: 'string',
      required: true,
    },
  ];

  useEffect(() => {
    const partnerPayload: SelectPayload = {
      SKey: 'PartnerSource',
    };

    const roleAdminPayload: SelectPayload = {
      SKey: 'AdminRole',
    };
    const rolePayload: SelectPayload = {
      SKey: 'PartnerRole',
    };

    // setIsLoading(false);
    getSelectList(partnerPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setPartners(res.data);
    });

    getSelectList(roleAdminPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setAdminList(res.data);
    });

    getSelectList(rolePayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setRoles(res.data);
    });
  }, []);

  const validation = useLoginValidation();
  const handleSubmit = useCallback(
    async (values: UserPayload) => {
      setLoading(true);
      values.isActive = 1;
      values.name = values.firstName + ' ' + values.lastName;
      values.username = values.firstName + ' ' + values.lastName;
      values.userName = sessionStorage.getItem('user')?.toString();

      if (values.sourceId == '0') {
        message.warn('Please select Partner!!!');
      }

      if (values.sourceId == null) {
        values.sourceId = sessionStorage.getItem('sourceId')?.toString();
      }

      adduserList(values)
        .then((_res) => {
          setUser(_res.data);
          if (_res.data.emailID != null)
            message.success(
              'User With email address ' +
              _res.data.emailID.toString() +
              ' has been created Successfully!'
            );
          //message.success('Success');
          form.resetFields();
          onSubmit(_res.data);
          navigate('/master/user');
        })
        .finally(() => {
          setLoading(false);
        });
      //values.departmentId = sessionStorage.getItem('sourceId')?.toString();
    },
    [onSubmit, form]
  );

  const handleUserName = (e: any) => {
    setUserName(e.target.value);
    console.log('Name Entered');
  };
  const handlePassword = (e: any) => {
    setPassword(e.target.value);
    console.log('Password Entered');
  };
  const handleFirstName = (e: any) => {
    setFirstName(e.target.value);
    console.log('FirstName Entered');
  };
  const handleLastName = (e: any) => {
    setLastName(e.target.value);
    console.log('LastName Entered');
  };
  const handleRoleId = (e: any) => {
    form.setFieldValue('roleId', e);
    form.validateFields(['roleId']);
    setRoleId(Number(e));
  };

  const handleSourceId = (e: any) => {
    form.setFieldValue('sourceId', e);
    form.validateFields(['sourceId']);
    setSourceId(Number(e));
  };
  const handleReset = async (_e: any) => {
    form.resetFields();
  };

  return (
    <div>
      {/* <div className="message">{message ? <p>{message}</p> : null}</div> */}
      <Spin spinning={isLoading}>
        <Form<UserPayload> form={form} layout="vertical" scrollToFirstError onFinish={handleSubmit}>
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'First Name :'}
                  name="firstName"
                  className="fieldTitle"
                  rules={required}
                >
                  <Input
                    placeholder={'First Name'}
                    onChange={handleFirstName}
                    id="firstname"
                    value={firstname}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Last Name:'}
                  name="lastName"
                  className="fieldTitle"
                  rules={required}
                >
                  <Input
                    placeholder={'Last Name'}
                    onChange={handleLastName}
                    id="lastname"
                    value={lastname}
                  />
                </Form.Item>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Email Address:'}
                  name="emailID"
                  className="fieldTitle"
                  rules={validation.username}
                >
                  <Input
                    placeholder={'Email Address'}
                    onChange={handleUserName}
                    id="username"
                    value={username}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Password :'}
                  name="password"
                  className="fieldTitle"
                  rules={passwordPolicyRules}
                >
                  <Input
                    placeholder={'Password'}
                    type="password"
                    onChange={handlePassword}
                    id="password"
                    value={password}
                  />
                </Form.Item>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                {!isAdmin ? (
                  <Form.Item
                    label={'Role :'}
                    name="roleId"
                    className="fieldTitle"
                    rules={required}
                    initialValue="Select"
                  >
                    <Select
                      size="large"
                      value={roleId.toString()}
                      onSelect={handleRoleId}
                      placeholder="Select"
                    >
                      {adminList.map((role) => (
                        <>
                          <Option value={role.SValue}>{role.SText}</Option>
                        </>
                      ))}
                    </Select>
                  </Form.Item>
                ) : (
                  <Form.Item
                    label={'Role :'}
                    name="roleId"
                    className="fieldTitle"
                    rules={required}
                    initialValue={roleList[0]?.SValue}
                  >
                    <Select size="large" onSelect={handleRoleId} placeholder="Select">
                      {roleList.map((role) => (
                        <>
                          <Option value={role.SValue}>{role.SText}</Option>
                        </>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </div>
            </div>
            {!isAdmin ? (
              <div className="col-xs-12 col-sm-6 col-md-6">
                <div className="input-box">
                  <Form.Item label={'Partner Name :'} name="sourceId" rules={required}>
                    <Select
                      size="large"
                      value={sourceId.toString()}
                      onSelect={handleSourceId}
                      placeholder="Select"
                    >
                      {partnerList.map((partner) => (
                        <>
                          <Option value={partner.SValue}>{partner.SText}</Option>
                        </>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            ) : null}
          </div>
          <div style={{ marginBottom: '20px' }}>
            <Button
              type="primary"
              style={{ float: 'right', marginLeft: '15px', marginBottom: '10px' }}
              onClick={handleReset}
            >
              {'Clear'}
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ float: 'right', marginBottom: '10px' }}
            >
              {'Add'}
            </Button>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default AddUser;
